import { URL } from '../../config'
import { getRequest } from './httpRequest'

export const checkRole = function(token) {
		const roleendpoint = '/userrole'
    const  userURL =  `${URL.user}${roleendpoint}` 
    return getRequest(userURL,'json',token)
}
  


// WEBPACK FOOTER //
// ./src/utils/functions/checkRole.js